import { DataGrid } from '@mui/x-data-grid';
import React from 'react'
import RTLInput from './RTLInput';
import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import persian_en from "react-date-object/locales/persian_en"
import { Box, FormControl, InputLabel, MenuItem, Modal, Select, TextField } from '@mui/material';
import { useState } from 'react';
import { getMEDRequestGroup } from './../api/routes';
import { useEffect } from 'react';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    maxHeight: '100vh',
    overflowY: 'auto',
    boxShadow: 24,
    borderRadius: '10px',
    p: 4,
};

export default function PatientTable({ data }) {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [clickedData, setClickedData] = useState();
    const [search, setSearch] = useState('')
    const [medRequestGroup, setMedRequestGroup] = useState([]);
    const [fromDate, setFromDate] = useState();
    const [toDate, setToDate] = useState()
    const [clickedRequestGroupId, setClickedRequestGroupId] = useState()

    const handleClickedReport = (data) => {
        setClickedData(data)
        handleOpen()
    }
    useEffect(() => {
        /*         getMEDRequestGroup((isOk, data) => {
                    if (!isOk) return alert(data.message);
                    else return setMedRequestGroup(data)
                }) */
    }, [])

    const columns = [
        { field: 'DateReception', headerName: 'تاریخ', width: 130 },
        {
            field: 'reportStatus',
            headerName: 'گزارش/تصویر',
            width: 130,
            align: 'center',
            sortable: false,
            renderCell: (params) => {
                if (!params.row.TextPlainReport || params.row.TextPlainReport === '')
                    return <p></p>
                else return <img src='/assets/images/medical-history.png' className='cursor-pointer' onClick={() => handleClickedReport(params.row)} alt='medical-history' />
            },
        },
        { field: 'idReception', headerName: 'کد پذیرش', width: 130 },
        {
            field: 'fullName',
            headerName: 'نام و نام خانوادکی',
            sortable: false,
            width: 200,
        },
        {
            field: 'CodeMelli',
            headerName: 'کدملی',
            sortable: false,
            width: 130
        },
        {
            field: 'NameGroups',
            headerName: 'گروه',
            sortable: false,
            width: 200
        },
        {
            field: 'NameFarsi',
            headerName: 'درخواست',
            sortable: false,
            width: 400
        }
    ];
    const mobileColumns = [
        {
            field: 'reportStatus',
            headerName: 'گزارش/تصویر',
            width: 90,
            align: 'center',
            renderCell: (params) => {
                if (!params.row.TextPlainReport || params.row.TextPlainReport === '')
                    return <p></p>

                else return <img src='/assets/images/medical-history.png' className='cursor-pointer' onClick={() => handleClickedReport(params.row)} alt='medical-history' />
            }
        },
        { field: 'DateReception', headerName: 'تاریخ', width: 100 },
        {
            field: 'fullName',
            headerName: 'نام و نام خانوادکی',
            sortable: false,
            width: 120,
        }
    ];
    const DatePickerCustom = ({ openCalendar, value, handleValueChange, placeholder }) => {
        return (
            <input onFocus={openCalendar}
                value={value}
                onChange={handleValueChange}
                placeholder={placeholder}
                className='w-full sm:w-[200px] h-[56px] border pr-2 bg-[#f8f9fb] lg:ml-4 rounded'
                style={{ borderColor: 'rgba(0, 0, 0, 0.23)' }}
            />
        )
    }

    return (
        <div style={{ width: '100%' }}>
            <RTLInput>
                <div className='grid grid-cols-1 sm:grid-cols-2 gap-2 sm:w-full w-[90%] mx-auto sm:place-items-center sm:justify-items-center lg:flex flex-wrap'>
                    <TextField label="نام بیمار" className='w-full sm:w-[200px] lg:ml-4' value={search} onChange={(event) => setSearch(event.target.value)} variant="outlined" />
                    <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        render={<DatePickerCustom placeholder="از تاریخ" />}
                        calendarPosition="bottom-right"
                        value={fromDate}
                        format="YYYY/MM/DD"
                        onChange={(date) => setFromDate(date)}
                        className='w-full'
                    />
                    <DatePicker
                        calendar={persian}
                        locale={persian_fa}
                        render={<DatePickerCustom placeholder="تا تاریخ" />}
                        calendarPosition="bottom-right"
                        value={toDate}
                        format="YYYY/MM/DD"
                        onChange={(date) => setToDate(date)}
                    />
             {/*        <FormControl className='w-full sm:w-[200px]'>
                        <InputLabel>گروه ها</InputLabel>
                        <Select
                            value={clickedRequestGroupId}
                            label="گروه ها"
                            onChange={(event => setClickedRequestGroupId(event.target.value))}
                        >
                            <MenuItem value={''}>نمایش همه</MenuItem>
                            {medRequestGroup.map(request => <MenuItem key={request.idRequestsGroups} value={request.idRequestsGroups}>{request.NameGroups}</MenuItem>)}
                        </Select>
                    </FormControl> */}
                </div>

                <div className='hidden sm:block' style={{ height: 650, width: '100%', marginTop: '1rem' }}>
                    <DataGrid
                        rows={data.filter(item => search !== '' ? item.fullName.match(new RegExp(`.*${search}.*`, "i")) : (fromDate && toDate && clickedRequestGroupId) ? item.DateReception >= fromDate?.convert(persian, persian_en).format() && item.DateReception <= toDate?.convert(persian, persian_en).format() && item.idRequestsGroups === clickedRequestGroupId : clickedRequestGroupId ? item.idRequestsGroups === clickedRequestGroupId : (fromDate && toDate) ? item.DateReception >= fromDate?.convert(persian, persian_en).format() && item.DateReception <= toDate?.convert(persian, persian_en).format() : true)}
                        columns={columns}
                        pageSize={10}
                        getRowId={(row) => row.idReceptionRequest}
                        rowsPerPageOptions={[10]}
                        disableMultipleSelection
                    />
                </div>
                <div className='block sm:hidden mx-auto' style={{ height: 650, width: '95%', marginTop: '1rem' }}>
                    <DataGrid
                        rows={data.filter(item => search !== '' ? item.fullName.match(new RegExp(`.*${search}.*`, "i")) : (fromDate && toDate && clickedRequestGroupId) ? item.DateReception >= fromDate?.convert(persian, persian_en).format() && item.DateReception <= toDate?.convert(persian, persian_en).format() && item.idRequestsGroups === clickedRequestGroupId : clickedRequestGroupId ? item.idRequestsGroups === clickedRequestGroupId : (fromDate && toDate) ? item.DateReception >= fromDate?.convert(persian, persian_en).format() && item.DateReception <= toDate?.convert(persian, persian_en).format() : true)}
                        columns={mobileColumns}
                        pageSize={10}
                        getRowId={(row) => row.idReceptionRequest}
                        rowsPerPageOptions={[10]}
                        disableMultipleSelection
                    />
                </div>
            </RTLInput>
            <Modal open={open} onClose={handleClose}>
                <Box sx={style} className='w-full md:w-[750px]'>
                    <div className='flex justify-between'>
                        <a href={`http://2.180.27.231:92/patreport.aspx?code=${clickedData?.idReception}`} target='_blank' rel="noreferrer">
                            <img src='/assets/images/report.png' alt='report' className='cursor-pointer w-11' />
                        </a>
                        <section className='flex text-sm items-end flex-col'>
                            <p className='mt-3'>تاریخ : {clickedData?.DateReception}</p>
                            <p className='my-1'>کد پذیرش : {clickedData?.idReception}</p>
                            <p>نام بیمار : {clickedData?.fullName}</p>
                        </section>
                    </div>
                    <p className='font-bold'>
                        حضور ارجمند دکتر {clickedData?.NameDoctorPatient}
                    </p>
                    <p className='mt-4'>{clickedData?.TextPlainReport}</p>
                </Box>
            </Modal>
        </div>
    )
}
